module.exports = __webpack_public_path__ + "img/fastgoLogo.1b0a9f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fastgoLogo.png
// module id = qoJ2
// module chunks = 2